"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divisor = exports.Item = exports.Home = exports.Wrapper = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.Wrapper = (0, flora_react_1.styled)('nav', {
    alignItems: 'center',
    display: 'flex',
    svg: {
        display: 'block',
    },
    a: {
        textDecoration: 'none',
    },
});
exports.Home = (0, flora_react_1.styled)('span', {
    color: '$backgroundAltPrimary',
    height: 24,
});
exports.Item = (0, flora_react_1.styled)(flora_react_1.Text, {
    alignItems: 'center',
    color: '$nonInteractivePredominant',
    display: 'flex',
    fontWeight: '$medium',
    a: {
        color: '$backgroundAltPrimary',
    },
});
exports.Divisor = (0, flora_react_1.styled)('span', {
    color: '$nonInteractiveAuxiliar',
    height: 24,
});
